import { Link, useLocation } from "react-router-dom";
import { useContext, useRef, useState, useEffect } from "react";
import { AuthContext } from "../context/AuthContext";
import { SVGS } from ".";
import { NavbarStrings } from "../consts/strings";

const Navbar = ({ prelineLoaded }) => {
  const { auth, logout } = useContext(AuthContext);
  const [isScrolled, setIsScrolled] = useState(false);

  const location = useLocation();
  const buttonRef = useRef(null);
  const navRef = useRef(null);
  const handleCollapse = () => {
    setTimeout(() => {
      window.innerWidth < 640 && buttonRef.current.click();
    }, 100);

    handleOverlay();
  };

  const handleOverlay = () => {
    const overlay = document.querySelector("#application-sidebar-backdrop");
    if (overlay) overlay.remove();

    // window.HSOverlay.close("#application-sidebar");
  };

  useEffect(() => {
    const scrollToHash = () => {
      const hash = location.hash;
      if (hash) {
        const element = document.querySelector(hash);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }
    };

    scrollToHash();
  }, [location]);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY < 1) {
        setIsScrolled(false);
      } else {
        setIsScrolled(true);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  if (!prelineLoaded) return;

  return (
    <header
      ref={navRef}
      className={`sticky top-0 flex flex-wrap sm:justify-start sm:flex-nowrap z-[999] w-full text-sm py-4   ${
        ["/", "/auth"].includes(location.pathname) && !isScrolled
          ? "bg-transparent"
          : "bg-white"
      } transition-colors duration-700 ease-in-out`}
    >
      <nav
        className="max-w-[85rem] w-full mx-auto px-4 sm:flex sm:items-center sm:justify-between"
        aria-label="Global"
      >
        <div className="flex items-center justify-between">
          <Link
            className="hs-collapse-toggle flex flex-row justify-center items-center text-xl font-semibold   cursor-pointer"
            to="/"
            onClick={() => {
              window.scrollTo({ top: 0, behavior: "smooth" });
              handleOverlay();
            }}
          >
            <div className="w-8 mr-2">
              <SVGS.LogoSVG />
            </div>

            <span className="text-2xl">{NavbarStrings.pageName}</span>
          </Link>

          <div className="sm:hidden">
            <button
              type="button"
              ref={buttonRef}
              className="hs-collapse-toggle p-2 inline-flex justify-center items-center gap-x-2 rounded-lg border border-gray-200 bg-white text-gray-800 shadow-sm hover:bg-gray-50 disabled:opacity-50 disabled:pointer-events-none        :bg-white/10  :outline-none  :ring-1  :ring-gray-600 cursor-pointer"
              data-hs-collapse="#navbar-with-mega-menu"
              aria-controls="navbar-with-mega-menu"
              aria-label="Toggle navigation"
            >
              <SVGS.NavbarBurgerMenu />
              <SVGS.NavbarBurgerMenuOpen />
            </button>
          </div>
        </div>
        <div
          id="navbar-with-mega-menu"
          className="hs-collapse hidden overflow-hidden transition-all duration-300 ease-in-out basis-full grow sm:block"
        >
          <div className="flex flex-col gap-5 mt-5 sm:flex-row sm:items-center sm:justify-end sm:mt-0 sm:ps-5 md:space-x-1">
            <Link
              className="font-medium text-gray-600 hover:text-gray-400    :text-gray-500  :outline-none  :ring-1  :ring-gray-600 cursor-pointer"
              to="/#recenzije"
              onClick={handleCollapse}
            >
              {NavbarStrings.testimonials}
            </Link>
            <Link
              className="font-medium text-gray-600 hover:text-gray-400    :text-gray-500  :outline-none  :ring-1  :ring-gray-600 cursor-pointer"
              to="/nova-pozivnica"
              type="button"
              onClick={handleCollapse}
            >
              {NavbarStrings.createRsvp}
            </Link>
            {auth?.isAuthenticated && (
              <Link
                className="font-medium text-gray-600 hover:text-gray-400    :text-gray-500  :outline-none  :ring-1  :ring-gray-600 cursor-pointer"
                to="/moje-pozivnice"
                type="button"
                onClick={handleCollapse}
              >
                {NavbarStrings.myRsvps}
              </Link>
            )}

            {/* <ThemeSwitcher /> */}

            <Link
              to="/auth"
              className={`${
                auth?.isAuthenticated && auth?.user?.avatar != null
                  ? "hidden"
                  : "block"
              }`}
            >
              <button
                type="button"
                className="border-2 border-yellow-500 font-semibold text-yellow-600 hover:border-yellow-400 rounded-md p-2"
                onClick={handleCollapse}
              >
                {NavbarStrings.login}
              </button>
            </Link>

            <div
              className={`${
                auth?.isAuthenticated && auth?.user?.avatar != null
                  ? "block"
                  : "hidden"
              }`}
            >
              <Dropdown
                image={auth?.user?.avatar}
                logout={logout}
                handleCollapse={handleCollapse}
                pathName={location.pathname}
              />
            </div>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Navbar;

const Dropdown = ({ image, logout, handleCollapse }) => {
  const avatarRef = useRef(null);
  // const pathname = useLocation().pathname;
  // const isNewInvite = pathname === "/nova-pozivnica";
  return (
    <div className="hs-dropdown [--strategy:static] sm:[--strategy:fixed] [--adaptive:none]">
      <button
        ref={avatarRef}
        type="button"
        id="hs-mega-menu-basic-dr"
        data-hs-collapse="#hs-mega-menu-basic-dr"
        aria-controls="hs-mega-menu-basic-dr"
        aria-label="Toggle navigation"
        className="flex items-center w-full text-gray-600 hover:text-gray-400 font-medium    :text-gray-500"
      >
        {image && image.length ? (
          <img src={image} alt="Profile" className="rounded-full h-9 w-9" />
        ) : (
          <div className="rounded-full h-9 w-9">
            <SVGS.DefaultAvatarSVG />
          </div>
        )}
      </button>
      <div
        className={`hs-dropdown-menu transition-[opacity,margin] duration-300 ease-in-out hs-dropdown-open:opacity-100 opacity-0 sm:w-48 z-10 sm:shadow-md rounded-lg p-2 sm:      before:absolute top-full sm:border before:-top-5 before:start-0 before:w-full before:h-5 hidden bg-transparent sm:bg-white`}
      >
        <button
          className="w-full flex items-center gap-x-3.5 py-2 px-3 rounded-lg text-sm text-gray-800 hover:bg-gray-100 focus:ring-2 focus:ring-teal-500    :bg-gray-700  :text-gray-300"
          onClick={() => {
            logout();
            setTimeout(() => handleCollapse(), 50);
          }}
        >
          {NavbarStrings.logout}
        </button>
      </div>
    </div>
  );
};
